var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"liuyan-out flex-center cursor",attrs:{"tag":"div","to":"/leavemsg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }